module.exports = __webpack_public_path__ + "img/Morbida.0101bb63.png";